import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/language.service';
import { ConfirmationDialogData } from '../confirmation-dialog-data';

/** Confirmation dialog give users the ability to provide final confirmation of a choice before committing to it, so they have a chance to change their minds if necessary. */

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  /** Confirmation dialog title */
  public title: string = "";
  /** Confirmation dialog message */
  public message: string = "";
  /** Showing list of elements with scrollbar depending on height */
  public elementList: string[] = [];
  /** Confirmatinon dialog warning sign */
  public warning: string = "";
  /** Confirmation dialog icon */
  public icon: string = "";
  /** Yes or no buttons */
  public buttons: string[] = [this.languageService.languageJSON.Global_Yes, this.languageService.languageJSON.Global_No];

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { data: ConfirmationDialogData },
    private languageService: LanguageService) {
    
    if (data.data.title) {
      this.title = data.data.title;
    }
    if (data.data.message) {
      this.message = data.data.message;
    }
    if (data.data.elementList) {
      this.elementList = data.data.elementList;
    }
    if (data.data.warning) {
      this.warning = data.data.warning;
    }
    if (data.data.buttons) {
      this.buttons = data.data.buttons;
    }
    if (data.data.icon) {
      this.icon = data.data.icon;
    }
  }

  ngOnInit() {
  }
}
